import { JournalingType } from "@/models/Journaling/JournalingTypes";

export enum EoPJournalingTypes {
    SERVICE_INVOICE = "SERVICE_INVOICE",
    RECHARGE_INVOICE = "RECHARGE_INVOICE",
    CHURN = "CHURN",
    CUSTOMER_INVOICE = "CUSTOMER_INVOICE",
    RVGF = "RVGF",
    CAR_PURCHASE = "CAR_PURCHASE",
    REMARKETING = "REMARKETING"
}